/**
 * Round a number to the nearest multiple of another number.
 */

export const roundToNearest = (multiple, v) => {
  if (multiple === 0) return Math.round(v);
  return Math.ceil(v / multiple) * multiple;
};
